import useBusinessPostApi from './useBusinessPostApi.js';

/**
 * @param {*} route
 * @param {{prompt: string}} opts
 */
const useDelete = (route, opts) => {
    const { save, isSaving } = useBusinessPostApi(route);

    function saveDelete() {
        if (confirm(opts?.prompt || 'Are you sure you want to delete this?')) {
            return save();
        } else {
            return {
                then: () => null,
                catch: () => null,
                finally: cb => cb && cb(),
            };
        }
    }

    return {
        saveDelete,
        isDeleting: isSaving,
    };
};

export default useDelete;
